import { useGetWorkspacesApiV1Suspense } from "@/api/__generated__/api.schema";
import { routes } from "@/constants/url";
import { Loading } from "@backpac/monica";
import { Suspense } from "react";
import { Navigate, useParams } from "react-router";

export function WorkspaceNavigator() {
  return (
    <Suspense fallback={<Loading.FullHeight />}>
      <RedirectDefaultWorkspace />
    </Suspense>
  );
}

function RedirectDefaultWorkspace() {
  const params = useParams();
  const {
    data: {
      data: { items: workspaces },
    },
  } = useGetWorkspacesApiV1Suspense();

  if (workspaces.length === 0) {
    // NOTE: Bad access
    return <Navigate to={routes.NOT_FOUND.root} replace />;
  }

  if (params.workspaceId != null) {
    return <Navigate to={`/workspaces/${params.workspaceId}`} replace />;
  }

  // NOTE: ignore saved workspace id
  const workspaceId = workspaces[0].id;

  return <Navigate to={`/workspaces/${workspaceId}`} replace />;
}
